// extracted by mini-css-extract-plugin
module.exports = {"root":"OrderCreatedInfo_root__3Jgoy","main":"OrderCreatedInfo_main__1lyIm","card":"OrderCreatedInfo_card__3oAFl"};